import React, { useState } from "react";
import i18n from "../../i18n";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";

const LanguageSwitcher = () => {
  const [open, setOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState("de");

  const languages = [
    { code: "de", short: "DE", name: "German", flag: "https://flagcdn.com/w20/de.png" },
    { code: "en", short: "EN", name: "English", flag: "https://flagcdn.com/w20/gb.png" },
    { code: "nl", short: "NL", name: "Dutch", flag: "https://flagcdn.com/w20/nl.png" }
  ];

  const currentLang = languages.find((l) => l.code === selectedLang);
  const otherLangs = languages.filter((l) => l.code !== selectedLang);

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    setSelectedLang(code);
    setOpen(false);
  };

  return (
    <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 9999 }}>
      {/* Main button */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          background: "white",
          padding: "8px 14px",
          borderRadius: "8px",
          border: "1px solid #ddd",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          minWidth: "70px",
          justifyContent: "space-between",
        }}
      >
        <img
          src={currentLang.flag}
          alt={currentLang.name}
          style={{ width: "20px", height: "14px", objectFit: "cover" }}
        />
        <span style={{ fontWeight: "500" }}>{currentLang.short}</span>
        {/* Outlined caret arrow */}
        {/* <span style={{ fontSize: "16px" }}>{open ? "▵" : "▿"}</span> */}
        {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </button>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            marginBottom: "6px",
            background: "white",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            padding: "6px 0",
            minWidth: "140px",
            position: "absolute",
            bottom: "110%",
            right: 0,
          }}
        >
          {otherLangs.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                width: "100%",
                padding: "8px 14px",
                background: "transparent",
                border: "none",
                textAlign: "left",
                cursor: "pointer",
                fontSize: "16px",
                color: "#333",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f2f2f2";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <img
                src={lang.flag}
                alt={lang.name}
                style={{ width: "20px", height: "14px", objectFit: "cover" }}
              />
              {lang.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;